export default {
  [['html', 'body', '#root'].join(',')]: {
    height: '100%',
  },
  '#root': {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  body: {
    fontFamily: 'Geologica, sans-serif',
  },
};
